<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">{{ formData.id ? '编辑合同' : '新增合同' }}</h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回</el-button>
        </div>

        <div class="content-wrap">
            <el-form :model="formData" :rules="rules" ref="contractForm" label-width="140px" v-loading="loading">
                <!-- 第一行：标段名称、中标人 -->
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="标段名称" prop="bidSectionCode" required>
                            <el-select v-model="formData.bidSectionCode" placeholder="请选择标段名称" filterable
                                @change="handleSectionChange" style="width: 100%">
                                <el-option v-for="item in sectionList" :key="item.bidSectionCode"
                                    :label="item.bidSectionName" :value="item.bidSectionCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="中标人" prop="winBidderUserId" required>
                            <el-select v-model="formData.winBidderUserId" placeholder="请选择中标人" filterable
                                @change="handleWinBidderChange" style="width: 100%">
                                <el-option v-for="item in winBidderList" :key="item.bidderCode" :label="item.bidderName"
                                    :value="item.bidderCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 第二行：项目属地、招标人 -->
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="项目所在地区" prop="projectLocation">
                            <el-input v-model="projectLocation" placeholder="请选择项目所在地区" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="招标人" prop="tendererName">
                            <el-input v-model="formData.tendererName" placeholder="招标人" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 第三行：合同名称、合同范围 -->
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="合同名称" prop="contractName" required>
                            <el-input v-model="formData.contractName" placeholder="请输入合同名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合同范围" prop="contractScope">
                            <el-input v-model="formData.contractScope" placeholder="请输入合同范围"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 第四行：合同编号、合同类别 -->
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="合同编号" prop="contractCode">
                            <el-input v-model="formData.contractCode" placeholder="合同编号" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合同类别" prop="contractTypeCode">
                            <el-select v-model="formData.contractTypeCode" placeholder="请选择合同类别" style="width: 100%">
                                <el-option label="设计合同备案（合同备案文书）" value="HA"></el-option>
                                <el-option label="勘察合同备案（合同备案文书）" value="HB"></el-option>
                                <el-option label="施工总包合同备案（合同备案文书）" value="HZ"></el-option>
                                <el-option label="施工分包合同备案（合同备案文书）" value="HF"></el-option>
                                <el-option label="施工劳务合同备案（合同备案文书）" value="HL"></el-option>
                                <el-option label="监理合同备案（合同备案文书）" value="HE"></el-option>
                                <el-option label="设计施工一体化（合同备案文书）" value="HC"></el-option>
                                <el-option label="工程总承包合同备案（合同备案文书）" value="HG"></el-option>
                                <el-option label="项目管理合同备案（合同备案文书）" value="HM"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 第五行：合同性质、合同签署时间 -->
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="合同性质" prop="contractNature">
                            <el-select v-model="formData.contractNature" placeholder="请选择合同性质" style="width: 100%">
                                <el-option label="正常合同" :value="1"></el-option>
                                <el-option label="变更合同" :value="2"></el-option>
                                <el-option label="其他合同" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合同签署时间" prop="contractSignDate">
                            <el-date-picker v-model="formData.contractSignDate" type="datetime" placeholder="选择合同签署时间"
                                style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 第六行：预计开工时间、预计竣工时间 -->
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="预计开工时间" prop="startTime">
                            <el-date-picker v-model="formData.startTime" type="datetime" placeholder="选择预计开工时间"
                                style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="预计竣工时间" prop="endTime">
                            <el-date-picker v-model="formData.endTime" type="datetime" placeholder="选择预计竣工时间"
                                style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 第七行：工期 -->
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="工期" prop="duration">
                            <el-input v-model="formData.duration" placeholder="请输入工期"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合同价格" prop="contractPrice" required>
                            <el-input v-model.number="formData.contractPrice" placeholder="请输入合同价格" type="number"
                                :min="0">
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 第八行：总负责人名称、总负责人身份证号 -->
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="总负责人名称" prop="projectLeaderName">
                            <el-input v-model="formData.projectLeaderName" placeholder="请输入总负责人名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="总负责人身份证号" prop="projectLeaderIdcard">
                            <el-input v-model="formData.projectLeaderIdcard" placeholder="请输入总负责人身份证号"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 第九行：合同签署时间、行业分类 -->
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="合同签署时间" prop="contractSignDate2">
                            <el-date-picker v-model="formData.contractSignDate" type="datetime" placeholder="选择合同签署时间"
                                style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                </el-row>


                <!-- 第十一行：是否使用平台签章、合同价格形式 -->
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="是否使用平台签章" prop="isSign">
                            <el-radio-group v-model="formData.isSign">
                                <el-radio :label="1">使用</el-radio>
                                <el-radio :label="0">不使用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合同价格形式" prop="priceFormCode">
                            <el-radio-group v-model="formData.priceFormCode">
                                <el-radio :label="1">金额</el-radio>
                                <el-radio :label="2">费率</el-radio>
                                <el-radio :label="3">单价</el-radio>
                                <el-radio :label="9">其他</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 第十三行：其他形式合同报价 -->
                <el-row :gutter="20" v-if="formData.priceFormCode === 9">
                    <el-col :span="24">
                        <el-form-item label="其他形式合同报价" prop="otherContractPrice" style="width: 50%;">
                            <el-input v-model="formData.otherContractPrice" placeholder="请输入其他形式合同报价"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 第十四行：是否提交履约保证金 -->
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="是否提交履约保证金" prop="isCommitMargin">
                            <el-radio-group v-model="formData.isCommitMargin">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 履约保证金相关字段 -->
                <template v-if="formData.isCommitMargin === 1">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="履约保证金金额" prop="margin">
                                <el-input v-model.number="formData.margin" placeholder="请输入履约保证金金额" type="number">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="履约保证金递交方式" prop="marginPayForm">
                                <el-select v-model="formData.marginPayForm" placeholder="请选择递交方式" style="width: 100%">
                                    <el-option label="现金" :value="1"></el-option>
                                    <el-option label="银行保函" :value="2"></el-option>
                                    <el-option label="保证保险" :value="3"></el-option>
                                    <el-option label="其他" :value="4"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </template>

                <!-- 合同内容（富文本编辑器） -->
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="合同内容" prop="contractContent">
                            <RichTextEditor v-model="formData.contractContent" :height="400" placeholder="请输入合同内容" />
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 附件上传 -->
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="合同主要附件">
                            <el-upload class="upload-demo" action="#" :http-request="handleUpload"
                                :on-remove="handleFileRemove" :file-list="fileList" :limit="10">
                                <el-button size="small" type="primary"
                                    v-if="handle === 'add' || handle === 'edit'">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">支持上传文件，单个文件不超过 100M</div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 操作按钮 -->
                <el-row :gutter="20">
                    <el-col :span="24" style="text-align: center; margin-top: 20px;">
                        <el-button @click="handleBack">{{ handle === 'add' || handle === 'edit' ? '取消' : '关闭'
                            }}</el-button>
                        <el-button type="primary" @click="handleSave(0)" :loading="saveLoading"
                            v-if="handle === 'add' || handle === 'edit'">暂存</el-button>
                        <el-button type="primary" @click="handleSave(1)" :loading="submitLoading"
                            v-if="handle === 'add' || handle === 'edit'">提交</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </div>
</template>

<script>
import { contractAdd, getBidSectionList, contractDetail, contractInit } from '@/api/contract/api'
import { loadProjectDetail } from '@/utils/projectInfo.js'
import RichTextEditor from '@/components/common/RichTextEditor.vue'
import { doFileUpload } from '@/utils/fileUploadHelper'
import { getFileDownloadList, getFileList } from '@/api/base/api'

export default {
    components: {
        RichTextEditor
    },
    data() {
        return {
            handle: 'add',
            projectTitle: '',
            projectCode: this.$route.query.projectCode,
            contractCode: this.$route.query.contractCode,
            loading: false,
            saveLoading: false,
            submitLoading: false,
            sectionList: [],
            winBidderList: [],
            fileList: [],
            uploadedFileGuids: [],
            fileBindId: '',
            formData: {
                bidSectionCode: '',
                bidSectionName: '',
                contractCode: '',
                contractContent: '',
                contractName: '',
                contractNature: null,
                contractPrice: null,
                contractScope: '',
                contractSignDate: '',
                contractTypeCode: '',
                duration: '',
                endTime: '',
                fileGuid: '',
                industriesTypeCode: '',
                industriesTypeName: '',
                isCommitMargin: 0,
                isSign: 1,
                isUnion: 0,
                margin: null,
                marginPayForm: null,
                otherContractPrice: '',
                priceFormCode: 1,
                projectCode: this.$route.query.projectCode,
                projectLeaderIdcard: '',
                projectLeaderName: '',
                regionCityCode: '',
                regionCityName: '',
                regionCode: '',
                regionName: '',
                regionProvinceCode: '',
                regionProvinceName: '',
                startTime: '',
                status: 0,
                tendererName: '',
                winBidderName: '',
                winBidderUserId: ''
            },
            projectLocation: '',
            rules: {
                bidSectionCode: [{ required: true, message: '请选择标段名称', trigger: 'change' }],
                winBidderUserId: [{ required: true, message: '请选择中标人', trigger: 'change' }],
                contractName: [{ required: true, message: '请输入合同名称', trigger: 'blur' }],
                contractPrice: [{ required: true, message: '请输入合同价格', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        this.getProjectInfo()
        if (this.contractCode) {
            this.getContractDetail()
            this.handle = this.$route.query.handle
        } else {
            this.fileBindId = Date.now().toString() + Math.floor(Math.random() * 100000)
            this.contractInit()
            this.getBidSectionList()
        }

    },
    methods: {
        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },

        // 获取标段列表
        async getBidSectionList() {
            try {
                const res = await getBidSectionList({ projectCode: this.projectCode })
                if (res.code === 200 && res.data) {
                    this.sectionList = res.data
                } else {
                    this.$message.error(res.msg || '获取标段列表失败')
                }
            } catch (error) {
                console.error('获取标段列表失败:', error)
            }
        },

        // 标段选择变化
        async handleSectionChange(bidSectionCode) {
            const section = this.sectionList.find(item => item.bidSectionCode === bidSectionCode)
            if (section) {
                this.formData.bidSectionName = section.bidSectionName
            }

            // 获取标段其他信息
            this.loading = true
            try {
                const res = await contractInit({ bidSectionCode: bidSectionCode, stage: 0 })
                if (res.code === 200 && res.data) {
                    const data = res.data
                    // 填充表单数据
                    this.formData.industriesTypeCode = data.industryCode
                    this.formData.industriesTypeName = data.industryName
                    // 项目所在地区（仅用于显示）
                    this.projectLocation = `${data.projectLocationProvince || ''}${data.projectLocationCity || ''}${data.projectLocation || ''}`
                    this.formData.regionProvinceName = data.projectLocationProvince
                    this.formData.regionProvinceCode = data.projectLocationProvinceCode
                    this.formData.regionCityName = data.projectLocationCity
                    this.formData.regionCityCode = data.projectLocationCityCode
                    this.formData.regionName = data.projectLocation
                    this.formData.regionCode = data.projectLocationCode
                    this.formData.tendererName = data.tendererName

                    // 设置中标人列表
                    if (data.winBidders && data.winBidders.length > 0) {
                        this.winBidderList = data.winBidders
                    }
                } else {
                    this.$message.error(res.msg || '获取标段信息失败')
                }
            } catch (error) {
                console.error('获取标段信息失败:', error)
                this.$message.error('获取标段信息失败')
            } finally {
                this.loading = false
            }
        },

        // 中标人选择变化
        handleWinBidderChange(bidderCode) {
            const bidder = this.winBidderList.find(item => item.bidderCode === bidderCode)
            if (bidder) {
                this.formData.winBidderName = bidder.bidderName
                this.formData.isUnion = bidder.isUnion || 0
            }
        },

        // 自定义文件上传
        async handleUpload(params) {
            const { file } = params
            try {
                file.fileType = 'contract'
                const result = await doFileUpload(file, {
                    fileBindId: this.fileBindId,
                    onProgress: (percentage) => {
                        file.percentage = percentage
                    },
                    onSuccess: (result) => {
                        this.$message.success('文件上传成功')
                        // 保存 fileGuid
                        if (result.fileGuid) {
                            this.uploadedFileGuids.push(result.fileGuid)
                            // 更新 formData 中的 fileGuid（多个文件用逗号分隔）
                            this.formData.fileGuid = this.uploadedFileGuids.join(',')
                        }
                        // 添加到文件列表
                        this.fileList.push({
                            name: file.name,
                            url: result.filePath,
                            fileGuid: result.fileGuid,
                            status: 'success'
                        })
                    },
                    onError: (error) => {
                        this.$message.error(error.message || '文件上传失败')
                    }
                })
            } catch (error) {
                console.error('文件上传失败:', error)
                this.$message.error('文件上传失败')
            }
        },

        // 文件移除
        handleFileRemove(file, fileList) {
            if (file.fileGuid) {
                const index = this.uploadedFileGuids.indexOf(file.fileGuid)
                if (index > -1) {
                    this.uploadedFileGuids.splice(index, 1)
                    this.formData.fileGuid = this.uploadedFileGuids.join(',')
                }
            }
            this.fileList = fileList
        },

        // 获取合同详情（编辑时）
        async getContractDetail() {
            this.loading = true
            try {
                const res = await contractDetail({ contractCode: this.contractCode })
                if (res.code === 200 && res.data) {
                    const data = res.data
                    this.formData = { ...data }
                    // 设置项目所在地区（用于显示）
                    this.projectLocation = `${data.regionProvinceName || ''}${data.regionCityName || ''}${data.regionName || ''}`
                    // 设置标段列表（用于下拉选择显示标段名称）
                    if (data.bidSectionCode && data.bidSectionName) {
                        this.sectionList = [{
                            bidSectionCode: data.bidSectionCode,
                            bidSectionName: data.bidSectionName
                        }]
                    }
                    // 设置中标人列表（用于下拉选择）
                    if (data.winBidderUserId && data.winBidderName) {
                        this.winBidderList = [{
                            bidderCode: data.winBidderUserId,
                            bidderName: data.winBidderName,
                            isUnion: data.isUnion || 0
                        }]
                    }
                    this.fileBindId = res.data.fileBindId
                    this.getFileDownloadList(res.data.fileGuid)
                } else {
                    this.$message.error(res.msg || '获取合同详情失败')
                }
            } catch (error) {
                console.error('获取合同详情失败:', error)
                this.$message.error('获取合同详情失败')
            } finally {
                this.loading = false
            }
        },
    /**
     * 获取文件下载列表
     */
        async getFileDownloadList(fileGuid) {
            if (!fileGuid) {
                this.fileList = []
                return
            }
            try {
                const res = await getFileList(fileGuid)
                if (res.code === 200 && res.data) {
                    if (res.data.length > 0) {
                        let file = res.data;
                        for (let index = 0; index < file.length; index++) {
                            const element = file[index];
                            this.fileList.push({
                                name: element.fileName,
                                url: element.fileUrl
                            })
                        }
                    } else {
                        this.fileList = []
                    }
                } else {
                    this.$message.error(res.msg || '获取文件列表失败')
                }
            } catch (error) {
                console.error('获取文件下载列表失败:', error)
                this.$message.error('获取文件下载列表失败，请重试')
            }
        },

        // 保存/提交
        async handleSave(status) {
            this.$refs.contractForm.validate(async (valid) => {
                if (!valid) {
                    this.$message.warning('请完善必填项')
                    return
                }

                const loading = status === 0 ? 'saveLoading' : 'submitLoading'
                this[loading] = true

                try {
                    const submitData = {
                        ...this.formData,
                        status: status,
                        fileGuid: this.fileBindId
                    }

                    const res = await contractAdd(submitData)
                    if (res.code === 200) {
                        this.$message.success(status === 0 ? '暂存成功' : '提交成功')
                        this.$router.go(-1)
                    } else {
                        this.$message.error(res.msg || '操作失败')
                    }
                } catch (error) {
                    console.error('保存失败:', error)
                    this.$message.error('操作失败')
                } finally {
                    this[loading] = false
                }
            })
        },

        // 返回
        handleBack() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-title {
    font-size: 16px;
    font-weight: 600;
    color: @gray-700;
    margin: 0;
    line-height: 1.5;
    position: relative;
    padding-left: 10px;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 16px;
        background: @primary-color;
        border-radius: 2px;
    }

    &:nth-child(2)::before {
        background: @gray-700;
    }
}

.content-wrap {
    background: #fff;
    padding: 30px;
    border-radius: 4px;
    box-shadow: @shadow-sm;
    margin-top: 20px;
}

.contract-form {
    /deep/ .el-form-item__label {
        color: @gray-700;
        font-weight: 500;
    }

    /deep/ .el-input__inner,
    /deep/ .el-textarea__inner {
        border-color: @gray-300;
        border-radius: 4px;
        color: @gray-700;

        &:focus {
            border-color: @primary-color;
        }

        &::placeholder {
            color: @gray-400;
        }

        &:disabled {
            background-color: @gray-100;
            color: @gray-500;
        }
    }
}

.upload-demo {
    /deep/ .el-upload__tip {
        color: @gray-500;
        font-size: 12px;
        margin-top: 7px;
    }
}

// 表格样式
.el-table {
    border: 1px solid @gray-200;
    border-radius: 4px;

    /deep/ .el-table__header {
        th {
            background-color: @gray-100;
            color: @gray-700;
            font-weight: 600;
        }
    }

    /deep/ .el-table__body {
        tr:hover {
            background-color: @gray-50;
        }
    }
}

// 底部按钮区域
.form-actions {
    text-align: center;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid @gray-200;

    .el-button {
        margin: 0 10px;
        padding: 12px 40px;

        &.el-button--primary {
            background-color: @primary-color;
            border-color: @primary-color;

            &:hover {
                background-color: @primary-hover;
                border-color: @primary-hover;
            }
        }

        &:not(.el-button--primary) {
            background-color: #fff;
            border-color: @gray-300;
            color: @gray-600;

            &:hover {
                color: @primary-color;
                border-color: @primary-color;
                background-color: @primary-light;
            }
        }
    }
}
</style>
